import React from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import {
  CategoryActivityType,
  useGqlCategoryDropdownQuery,
} from 'generated/graphql'
import { PAGE_SIZE } from '@app.feature/coverletter/coverletter.write/module/constant'
import { useDutyModalStore } from '../../../store/dutyModal'

gql`
  query gqlCategoryDropdown($filterBy: CategoryFilter) {
    categories(filterBy: $filterBy) {
      id
      name
    }
  }
`

const CategoryDropdown: React.FC = () => {
  const { data } = useGqlCategoryDropdownQuery({
    variables: {
      filterBy: {
        activityType: CategoryActivityType.RECRUIT,
        parentId: null,
      },
    },
  })

  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const handleAllItemClick = () => {
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
        categoryId: undefined,
      },
      pagination: {
        ...variables?.pagination,
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
  }

  const handleCategoryClick = (categoryId?: string) => {
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
        categoryId,
      },
      pagination: {
        ...variables?.pagination,
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
  }

  return (
    <StyledWrapper>
      <div className="dropdown-item" onClick={handleAllItemClick}>
        전체
      </div>
      {(() => {
        if (!data?.categories) return null

        return data.categories.map((category) => (
          <div
            className="dropdown-item"
            key={`CategoryDropdown-${category.id}`}
            onClick={() => handleCategoryClick(category.id)}
          >
            {category.name}
          </div>
        ))
      })()}
    </StyledWrapper>
  )
}

export default CategoryDropdown

const StyledWrapper = styled.div`
  padding: 6px 0;
  width: 120px;
  position: absolute;
  top: calc(100% + 5px);
  left: calc(50% - 7px);
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #cccccc;
  z-index: 10;
  border-radius: 5px;
  cursor: pointer;
  .dropdown-item {
    padding: 8px 16px;
    color: #333333;
    font-size: 12px;
    height: 32px;
    text-align: start;
    &:hover {
      background-color: #f8f8f8;
    }
  }
`
